import React, { forwardRef, Ref, useImperativeHandle, useRef, useState } from 'react';
import { Transforms, Selection } from 'slate';
import { Overlay, OverlayElement, OverlayExtendProps } from 'components/_new/Overlay';
import { Box, BoxSection } from 'components/_new/Box';
import { Button } from 'components/_new/Button';
import { insertLink } from '../../utils/link';
import { LinkEditForm, useEditLinkForm } from './LinkEditForm';
import { CustomEditor } from '../../types';

type InsertLinkPopupProps = {
	editor: CustomEditor;
} & Pick<OverlayExtendProps, 'onOpenStateChange'>;

export const InsertLinkPopup = forwardRef(
	({ onOpenStateChange, editor }: InsertLinkPopupProps, ref: Ref<OverlayElement>) => {
		const overlayRef = useRef<OverlayElement>(null);
		const [selection, setSelection] = useState<Selection>(null);
		const [formState, formReset] = useEditLinkForm();
		const { url, openInNewTab } = formState[0];

		useImperativeHandle(ref, () => ({
			open: () => {
				//
			},
			close: () => {
				//
			},
			isOpen: () => {
				return false;
			},
			toggle: (element) => {
				setSelection(editor.selection);
				if (overlayRef?.current) {
					overlayRef.current.toggle(element);
				}
			},
			getElement: () => overlayRef?.current?.getElement() || null,
		}));

		const handleInsertLink = () => {
			if (selection) {
				Transforms.select(editor, selection);
				insertLink(editor, { url, openInNewTab });
				formReset();
			}
			overlayRef?.current?.close();
		};

		return (
			<Overlay ref={overlayRef} onOpenStateChange={onOpenStateChange}>
				<Box variant="white-bordered" className="editor-popup" dropShadow>
					<BoxSection>
						<LinkEditForm formState={formState} />
						<div className="flex flex-row justify-content-end">
							<Button label="Wstaw" onClick={handleInsertLink} />
						</div>
					</BoxSection>
				</Box>
			</Overlay>
		);
	}
);
